// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.react-modal-overlay.confirm-sticker-removal-modal {
  display: grid;
  place-items: center;
}
.react-modal-overlay.confirm-sticker-removal-modal .react-modal {
  width: 35.5rem;
  margin: auto;
  padding: 24px 0;
  font-family: Poppins;
  text-align: center;
  font-size: 2rem;
  color: #696969 !important;
  left: unset;
  top: unset;
  right: unset;
  bottom: unset;
}
.react-modal-overlay.confirm-sticker-removal-modal .react-modal .heading {
  font-size: 2.4rem;
  font-weight: 600;
  text-transform: unset;
  color: #292727;
  margin-top: 1.6rem;
}
.react-modal-overlay.confirm-sticker-removal-modal .react-modal p {
  margin-bottom: 3.2rem;
}
.react-modal-overlay.confirm-sticker-removal-modal .react-modal .modal-top-buttons {
  display: none;
}
.react-modal-overlay.confirm-sticker-removal-modal .react-modal-content .sticker {
  height: 104px;
  width: 100%;
  -o-object-fit: contain;
     object-fit: contain;
}
.react-modal-overlay.confirm-sticker-removal-modal .react-modal-content #cancel-button {
  display: inline-block;
  padding: 1rem 1.6rem;
  font-size: 1.6rem;
  color: #ab3a72;
  margin-right: 1.2rem;
}
.react-modal-overlay.confirm-sticker-removal-modal .react-modal-content #confirm-button {
  display: inline-block;
  background-color: #ab3a72;
  padding: 1rem 1.6rem;
  font-size: 1.6rem;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/Stickers/ConfirmStickerRemovalModal.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAAA;EACE,aAAA;EACA,mBAAA;AAGF;AADE;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;AAGJ;AADI;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cDrBM;ECsBN,kBAAA;AAGN;AAAI;EACE,qBAAA;AAEN;AACI;EACE,aAAA;AACN;AAGM;EACE,aAAA;EACA,WAAA;EACA,sBAAA;KAAA,mBAAA;AADR;AAIM;EACE,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,cDvBE;ECwBF,oBAAA;AAFR;AAKM;EACE,qBAAA;EACA,yBD7BE;EC8BF,oBAAA;EACA,iBAAA;EACA,YAAA;AAHR","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n\n.react-modal-overlay.confirm-sticker-removal-modal {\n  display: grid;\n  place-items: center;\n\n  .react-modal {\n    width: 35.5rem;\n    margin: auto;\n    padding: 24px 0;\n    font-family: Poppins;\n    text-align: center;\n    font-size: 2rem;\n    color: $darkTextColor !important;\n    left: unset;\n    top: unset;\n    right: unset;\n    bottom: unset;\n\n    .heading {\n      font-size: 2.4rem;\n      font-weight: 600;\n      text-transform: unset;\n      color: $textColor;\n      margin-top: 1.6rem;\n    }\n\n    p {\n      margin-bottom: 3.2rem;\n    }\n\n    .modal-top-buttons {\n      display: none;\n    }\n\n    &-content {\n      .sticker {\n        height: 104px;\n        width: 100%;\n        object-fit: contain;\n      }\n\n      #cancel-button {\n        display: inline-block;\n        padding: 1rem 1.6rem;\n        font-size: 1.6rem;\n        color: $magenta;\n        margin-right: 1.2rem;\n      }\n\n      #confirm-button {\n        display: inline-block;\n        background-color: $magenta;\n        padding: 1rem 1.6rem;\n        font-size: 1.6rem;\n        color: white;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
